module.exports = __webpack_public_path__ + "img/farm_house.e562694a.jpg";